import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { primaryColor } from "../../Constants";


const MuiDatePicker = ({ label, value, onChange, disabled, maxDate, minDate, required }) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#4F46E5",
      },
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#4f46e5",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: value ? "#4F46E5" : undefined,
              borderWidth: value ? "2px" : "1px",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#4f46e5",
            },
            "&.Mui-disabled": {
              borderRadius: "8px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 0, 0, 0.38)",
                borderWidth: "2px",
              },
            },
            "& .MuiInputBase-input": {
              color: "rgb(17, 24, 39)",
            },
          },
        },
      },
      MuiInputLabel: { 
        styleOverrides: {
          root: {
            color: value ? "#6b7280" : undefined,
            "&.Mui-focused": {
              color: "#6b7280",
            },
            "&.Mui-disabled": {
              color: "#6b7280",
            },
            "& .MuiFormLabel-asterisk": {
              color: "#ef4444",
            },
          },
        },
      },
    },
  });
  const [open, setOpen] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          label={label}
          value={value}
          onChange={(date) => {
            if (date) {
              onChange(date);
              setOpen(false);
            }
          }}
          disabled={disabled}
          maxDate={maxDate || null}
          minDate={minDate || null}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          slotProps={{
            textField: {
              fullWidth: true,
              required: required,
              inputProps: { readOnly: true },
              sx: {
                "& .MuiOutlinedInput-root": {
                  minHeight: disabled ? "48px" : "48px",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: disabled ? "7px" : "8px",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#e5e7eb",
                  },
                  "& .MuiInputBase-input": {
                    color: "rgb(17, 24, 39)",
                  },
                },
                "& .MuiInputBase-input": {
                  padding: "8px 12px",
                  height: "1.5rem",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "rgb(17, 24, 39)",
                },
                "& .MuiFormLabel-root": {
                  color: value ? "#2F4F4F" : undefined,
                  "&.Mui-focused": {
                    color: "#2F4F4F",
                  },
                  "& .MuiFormLabel-asterisk": {
                    color: "#ef4444",
                  },
                },
                backgroundColor: "#FFFFFF",
              },
            },
            popper: { sx: { zIndex: 1300 } },
          }}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default MuiDatePicker;